import { InputBase } from '../../../classes/input-base';
import { InputRadio } from '../../../classes/input-radio';
import { InputText } from '../../../classes/input-text';

export class FeaturesStep4Form {
	title = new InputText({
		key: 'title',
		label: 'Book Title',
		required: true,
	});

	amazonLink = new InputText({
		key: 'amazonLink',
		label: 'Amazon Url',
		buttonSymbol: 'Go',
		required: true,
		blur: true,
	});

	link = new InputText({
		key: 'link',
		label: 'Book Link',
		required: true,
		blur: true,
	});

	author = new InputText({
		key: 'author',
		label: 'Author',
		required: true,
	});

	bookPriceDuringPromo = new InputText({
		key: 'bookPriceDuringPromo',
		label: 'Book Price During Promotion',
		required: true,
		type: 'number',
		addonSymbol: '$',
		min: 0,
	});

	email = new InputText({
		key: 'email',
		label: 'Email',
		required: true,
		pattern: 'email',
		helper: 'This is where we will send your confirmation email.',
	});

	firstName = new InputText({
		key: 'firstName',
		label: 'First Name',
		required: true,
	});

	lastName = new InputText({
		key: 'lastName',
		label: 'Last Name',
		required: true,
	});

	description = new InputBase({
		key: 'description',
		label: 'Book Description for Promotion',
		controlType: 'textarea',
		maxLength: 400,
		infoLabel: '(Must be 350 characters or less. Please don\'t copy from Amazon.)',
	});

	apple = new InputBase({
		key: 'apple',
		label: 'Is your book available on Apple Books?',
		controlType: 'checkbox',
		value: false,
	});

	nook = new InputBase({
		key: 'nook',
		label: 'Is your book available on Nook?',
		controlType: 'checkbox',
		value: false,
	});

	hardcover = new InputBase({
		key: 'hardcover',
		label: 'Is your book available on Hardcover?',
		controlType: 'checkbox',
		value: false,
	});

	paperback = new InputBase({
		key: 'paperback',
		label: 'Is your book available on Paperback?',
		controlType: 'checkbox',
		value: false,
	});

	audiobook = new InputBase({
		key: 'audiobook',
		label: 'Is your book available on Audiobook?',
		controlType: 'checkbox',
		value: false,
	});

	googleplay = new InputBase({
		key: 'googleplay',
		label: 'Is your book available on Google Play?',
		controlType: 'checkbox',
		value: false,
	});

	authorstore = new InputBase({
		key: 'authorstore',
		label: 'Is this book sold directly on your website?',
		controlType: 'checkbox',
		value: false,
		tooltip: '?',
		tooltipText: `Only check this box if readers can purchase or download your book directly from your website. 
		Your site must be able to process the transaction, without redirecting readers to other retailers, like Amazon.`,
	});

	smashwords = new InputBase({
		key: 'smashwords',
		label: 'Is your book available on SmashWords?',
		controlType: 'checkbox',
		value: false,
	});

	appleLink = new InputText({
		key: 'appleLink',
		label: 'Apple URL',
	});

	kobo = new InputBase({
		key: 'kobo',
		label: 'Is your book available on Kobo?',
		controlType: 'checkbox',
		value: false,
	});

	koboLink = new InputText({
		key: 'koboLink',
		label: 'Kobo URL',
	});

	audible = new InputBase({
		key: 'audible',
		label: 'Is your book available on Audible?',
		controlType: 'checkbox',
		value: false,
	});

	audibleLink = new InputText({
		key: 'audibleLink',
		label: '',
		placeholder: 'Enter audible link here',
	});

	nookLink = new InputText({
		key: 'nookLink',
		label: 'Nook URL',
	});

	hardcoverLink = new InputText({
		key: 'hardcoverLink',
		label: 'Hardcover URL',
	});

	paperbackLink = new InputText({
		key: 'paperbackLink',
		label: 'Paperback URL',
	});

	audiobookLink = new InputText({
		key: 'audiobookLink',
		label: 'Audiobook URL',
	});

	audiobookscom = new InputBase({
		key: 'audiobookscom',
		label: 'Is your book available on Audiobooks.com?',
		controlType: 'checkbox',
		value: false,
	});

	audiobookscomLink = new InputText({
		key: 'audiobookscomLink',
		label: '',
		placeholder: 'Enter audiobooks.com link here',
	});

	googleplayLink = new InputText({
		key: 'googleplayLink',
		label: 'Google Play URL',
		placeholder: 'Enter google play link here',
	});

	authorstoreLink = new InputText({
		key: 'authorstoreLink',
		label: '',
		placeholder: 'Enter website link here',
	});

	smashwordsLink = new InputText({
		key: 'smashwordsLink',
		label: '',
		placeholder: 'Enter smashwords link here',
	});

	appleAudioLink = new InputText({
		key: 'appleAudioLink',
		label: '',
		placeholder: 'Enter apple audio link here',
	});

	scribd = new InputBase({
		key: 'scribd',
		label: 'Is your book on Scribd?',
		controlType: 'checkbox',
		value: false,
	});

	scribdLink = new InputText({
		key: 'scribdLink',
		label: 'scribd URL',
	});

	koboAudioLink = new InputText({
		key: 'koboAudioLink',
		label: '',
		placeholder: 'Enter kobo audio link here',
	});

	nookAudioLink = new InputText({
		key: 'nookAudioLink',
		label: '',
		placeholder: 'Enter nook audio link here',
	});

	googleplayAudioLink = new InputText({
		key: 'googleplayAudioLink',
		label: '',
		placeholder: 'Enter google play audio link here',
	});

	appleAudio = new InputBase({
		key: 'appleAudio',
		label: 'Is your book available on Apple Audio?',
		controlType: 'checkbox',
		value: false,
	});

	koboAudio = new InputBase({
		key: 'koboAudio',
		label: 'Is your book available on Kobo Audio?',
		controlType: 'checkbox',
		value: false,
	});

	nookAudio = new InputBase({
		key: 'nookAudio',
		label: 'Is your book available on Nook Audio?',
		controlType: 'checkbox',
		value: false,
	});

	googleplayAudio = new InputBase({
		key: 'googleplayAudio',
		label: 'Is your book available on Google Play Audio?',
		controlType: 'checkbox',
		value: false,
	});

	permafree = new InputRadio({
		key: 'permafree',
		label: 'Is the title permafree?',
		options: [
			{ id: 'bookPermaFreeYES', label: 'YES', value: true },
			{ id: 'bookPermaFreeNO', label: 'NO', value: false },
		],
		value: false,
	});

	subscribeToList = new InputBase({
		key: 'subscribeToList',
		label: 'Add me to the reader list so I\'ll see my book promo when it runs (Highly Recommended)',
		controlType: 'checkbox',
		value: false,
	});

	terms = new InputBase({
		key: 'terms',
		label: '',
		controlType: 'checkbox',
		value: false,
	});
}
